import React, { Component } from "react";

import PropTypes from "prop-types";
import tw from "twin.macro";
import styled from "styled-components";
import Log, { TapLog } from "../../lib/log";
import { Link } from "react-router-dom";
import connectComponent from "../../redux/connectComponent";
import Errors, {
  setErrors,
  errorContains,
  errorsContain
} from "components/errors";
import {
  BoxForm,
  BoxHeadline,
  InputForm,
  AlternativeOption,
  Divider,
  WButton
} from "components/BoxForm";
import PasswordField from "screens/shared/forms/passwordField";
import withWrap from "components/withWrap";
const infoSVG = process.env.PUBLIC_URL + "/icons/info.svg";
import ReactModal from "react-modal";
import styles from "./styles";
import { PhoneField } from "../shared/forms/phoneField";
import ReactTooltip from "react-tooltip";

const InputMessageWarning = styled.p`
  ${tw`text-[14.4px] pt-2 pb-0 mb-0`}
  font-family: "Lato", Helvetica, sans-serif;
  color: #e18925;
`;

const WhyInfoModal = styled.div`
  ${tw`bg-white rounded`}
  border: 1px solid #32aa44;
  padding: 10vw 6.5vw;
  margin: 0.875em;
  max-width: 600px;

  p {
    ${tw`pb-0 mb-[14px] text-[1.125em] leading-[1.44]`}
    color: #323234;
  }
`;

const ModalCloseButton = styled.button`
  ${tw`w-full uppercase cursor-pointer text-white border-0 mt-5`}
  font-family: "circular-std", sans-serif;
  font-weight: 500;
  padding-top: 1rem;
  padding-bottom: 1rem;
  background: #33aa44;
  border-radius: 3px;
  letter-spacing: 0.6px;

  &:hover,
  &:active {
    cursor: pointer;
    background: #2d983d;
  }
`;

const WhyExplanation = styled.div`
  ${tw`flex items-center py-1.5 cursor-pointer relative`}
  width: max-content;

  img {
    margin-top: 1px;
  }

  p {
    ${tw`pb-0 mb-0 ml-1.5`}
  }

  @media screen and (max-width: 47.9375rem) {
    ${tw`p-0`}
    width: auto;

    img {
      margin-top: 0;
    }

    p {
      ${tw`text-[14.4px]`}
    }
  }
`;

const ShowOnlyDesktop = styled(WhyExplanation)`
  @media screen and (max-width: 47.9375rem) {
    display: none !important;
  }
`;

const ShowOnlyTablet = styled(WhyExplanation)`
  @media screen and (min-width: 48rem) {
    display: none !important;
  }
`;

const OutOfArea = styled.div`
  ${tw`flex justify-center mt-12 pt-12`}
`;

const OutOfAreaCol = styled.div`
  ${tw`w-full px-2 lg:w-2/3`}
`;

const withEvent = (event) => (callback) =>
  [event.preventDefault(), callback(event), false].pop();

export class Account extends Component {
  static propTypes = {
    actions: PropTypes.object,
    onRegister: PropTypes.func,
    onIncomplete: PropTypes.func,
    confirmationPath: PropTypes.string,
    registrationPath: PropTypes.string,
    sessionPath: PropTypes.string,
    heading: PropTypes.any,
    renderHeader: PropTypes.func,
    title: PropTypes.string,
    referrer: PropTypes.string
  };

  state = {
    error: null,
    errors: {},
    outOfArea: false,
    disabled: false,
    modal: false,
    contact: {},
    userState: null
  };

  constructor(props) {
    super(props);
    this.emailRef = React.createRef();
    this.passwordRef = React.createRef();
    this.registrationFormRef = React.createRef();
    this.emailSignupRef = React.createRef();
    this.userNameRef = React.createRef();
    this.userEmailRef = React.createRef();
    this.userPasswordRef = React.createRef();
    this.userPostalCodeRef = React.createRef();
    this.phoneRef = React.createRef();
  }

  componentDidMount() {
    this.resetErrors();
  }

  projectId = (props) =>
    props && props.match && props.match.params && props.match.params.id;

  onRegisterHandler = (event) =>
    withEvent(event)(() => this.onRegister(this.formValues()));

  resetErrors = () =>
    this.setState({
      errors: {},
      error: null
    });

  setClientSideError = (field, err) => {
    err &&
      this.setState({
        errors: {
          ...this.state.errors,
          [field]: [err]
        }
      });
  };

  clearClientSideError = (field) => {
    const { [field]: val, ...errs } = this.state.errors; // eslint-disable-line
    this.setState({
      errors: errs
    });
  };

  validateField = (field) => this.validateForm(field);

  validateForm = (field = null) => {
    const values = this.formValues();
    let validated = true;

    if ((!field || field == "name") && values.name.length < 3) {
      this.setClientSideError("name", "Name Required");
      validated = false;
    }

    if (
      (!field || field == "email") &&
      (values.email.length < 3 || !values.email.match(/@/))
    ) {
      this.setClientSideError("email", "Email Required");
      validated = false;
    }

    if ((!field || field == "password") && values.password.length < 6) {
      this.setClientSideError(
        "password",
        "Password required (at least 6 characters)" + values.password
      );
      validated = false;
    }

    if ((!field || field == "phone") && values.phone.length < 6) {
      this.setClientSideError("phone", "Phone required");
      validated = false;
    }

    ["postal_code"].forEach((f) => {
      if (
        (!field || field == f) &&
        this.state.errors[f] &&
        this.state.errors[f].length
      ) {
        this.setClientSideError(field, `${f} required`);
        validated = false;
      }
    });

    return validated;
  };

  register = (user) =>
    this.props.actions
      .registerAccount(user)
      .then(this.onSuccess)
      .catch(this.onFailure);

  exclude = () => () => this.setState({ outOfArea: true });

  onRegister = (userValues) => {
    if (this.state.disabled) return; // console.log("Form already submitting... button disabled")

    this.setState({ disabled: true });

    this.resetErrors();

    if (!this.validateForm()) {
      this.setState({ disabled: false });
      return false;
    }

    return this.register(userValues).catch((err) => {
      this.exclude(this.props)(err);
    });
  };

  onSuccess = (user) => {
    Log("onRegisterSuccess", user);
    return this.props.actions
      .refresh()
      .then(() => this.props.actions.optimizeEvent("sign_up"))
      .then(() => this.setState({ disabled: false }))
      .then(() => this.goToDestination(this.props))
      .catch(TapLog("Error Checking Authentication"));
  };

  onFailure = (errorResponse) => {
    this.setState({ disabled: false });
    return setErrors(this.setState.bind(this))(errorResponse);
  };

  goToDestination = (props) => {
    if (!props.database.authentication.complete(true)) {
      props.onIncomplete();
    } else if (this.props.onRegister) {
      props.onRegister();
    }
  };

  shouldGoToSignIn = (state) => errorsContain(state, /existing/);

  credentialError = (state) => errorContains(state, /credential|No Session/im);

  formValues = () => ({
    name: this.userNameRef.current.value,
    email: this.userEmailRef.current.value,
    password: this.userPasswordRef.current.value,
    postal_code: this.userPostalCodeRef.current?.value,
    phone: this.phoneRef.current && this.phoneRef.current.value,
    ...(Object.keys(this.state.contact).length ? this.state.contact : {})
  });

  registrationPath = (props) => props.registrationPath || "/registration";

  renderNavigationPrompt = (props, state) => {
    if (this.shouldGoToSignIn(state)) {
      return (
        <InputMessageWarning>
          You already have an account!{" "}
          <Link
            to={{
              pathname: props.sessionPath,
              state: { referrer: this.props.referrer }
            }}
            data-testid="signin-instead"
          >
            Sign In
          </Link>{" "}
          instead.
        </InputMessageWarning>
      );
    }

    return "";
  };

  openModal = (event) => {
    event.preventDefault();
    this.setState({ modal: true });
  };

  closeModal = (event) => {
    event.preventDefault();
    this.setState({ modal: false });
  };

  renderRegistration = (props, state) => (
    <React.Fragment>
      <BoxForm
        action="/"
        onSubmit={this.onRegisterHandler}
        ref={this.registrationFormRef}
      >
        {this.props.renderHeader ? (
          this.props.renderHeader()
        ) : (
          <BoxHeadline>Sign up</BoxHeadline>
        )}

        <Divider />

        <AlternativeOption>
          Already a member? &nbsp;
          <Link
            to={{
              pathname: this.props.sessionPath || "/session",
              state: { referrer: this.props.referrer }
            }}
            data-testid="signin"
          >
            Sign in
          </Link>
        </AlternativeOption>

        {this.renderForm(props, state)}

        <ReactModal
          isOpen={this.state.modal}
          style={styles.modal}
          contentLabel={this.props.title}
        >
          <WhyInfoModal>
            <p>
              We require your <strong>phone number</strong> so we can send you
              pickup and delivery details. We also require your{" "}
              <strong>home address</strong> so we can confirm your home delivery
              eligibility.
            </p>
            <ModalCloseButton type="button" onClick={this.closeModal}>
              Understood
            </ModalCloseButton>
          </WhyInfoModal>
        </ReactModal>

        <React.Fragment>
          <ShowOnlyDesktop data-tip="We require your <b>phone number</b> so we <br/>can send you pickup and delivery details. <br/>We also require your <b>home address</b> so we <br/>can confirm your home delivery eligibility.">
            <img src={infoSVG} alt="Info Icon" />
            <p>Why do we need this information?</p>
          </ShowOnlyDesktop>
          <ReactTooltip html={true} />

          <ShowOnlyTablet onClick={this.openModal}>
            <img src={infoSVG} alt="Info Icon" />
            <p>Why do we need this information?</p>
          </ShowOnlyTablet>
        </React.Fragment>

        <WButton
          type="submit"
          value={
            this.state.disabled ? "Signing Up..." : "Sign Up and Place an Order"
          }
          data-testid="signup"
        />
      </BoxForm>
    </React.Fragment>
  );

  setUserState = (userState) => this.setState({ userState });

  renderForm = (props, state) => (
    <React.Fragment>
      {this.renderNavigationPrompt(props, state)}

      <InputForm>
        <label htmlFor="fullname">Full Name</label>
        <input
          type="text"
          autoComplete="name"
          name="Full Name"
          required="required"
          ref={this.userNameRef}
          onFocus={() => this.clearClientSideError("name")}
          onBlur={() => this.validateField("name")}
          id="fullname"
        />
        <Errors errors={this.state.errors.name} />
      </InputForm>

      <InputForm>
        <label htmlFor="email">Email</label>
        <input
          type="email"
          name="Email"
          id="email"
          ref={this.userEmailRef}
          required="required"
          autoComplete="email"
          onFocus={() => this.clearClientSideError("email")}
          onBlur={() => this.validateField("email")}
        />
        <Errors errors={this.state.errors.email} />
      </InputForm>

      <PasswordField
        inputRef={this.userPasswordRef}
        errors={this.state.errors.password}
        inputProps={{
          onFocus: () => this.clearClientSideError("password"),
          onBlur: () => this.validateField("password")
        }}
      />

      <InputForm>
        <label htmlFor="postal_code">Postal Code</label>

        <input
          type="text"
          style={{ minHeight: 56 }}
          id="postal_code"
          ref={this.userPostalCodeRef}
          name="postal_code"
          autoComplete="postal-code"
          onFocus={() => this.clearClientSideError("postal_code")}
          onBlur={() => this.validateField("postal_code")}
          pattern="[0-9]{5}"
          required="required"
        />

        <Errors errors={this.state.errors.postalCode} />
      </InputForm>

      <InputForm>
        <label htmlFor="phone">Mobile Number</label>
        <PhoneField
          id="phone"
          title="Mobile Number"
          name="user_info[phone]"
          required="required"
          onFocus={() => this.clearClientSideError("phone")}
          onBlur={() => this.validateField("phone")}
          inputRef={this.phoneRef}
          style={{ minHeight: 56 }}
        />
        <Errors errors={this.state.errors.phone} />
      </InputForm>
    </React.Fragment>
  );

  shouldGoToNoThanks = (state) => state.outOfArea;

  render() {
    if (this.shouldGoToNoThanks(this.state)) {
      return (
        <OutOfArea>
          <OutOfAreaCol>
            <h1>Sorry, we are not in your area... yet!</h1>
            <p>We&#39;ll let you know as soon as we launch in your area.</p>
          </OutOfAreaCol>
        </OutOfArea>
      );
    }

    return this.renderRegistration(this.props, this.state);
  }
}

export default withWrap(
  connectComponent(Account, ["authentication", "professionals", "users"])
);
